<template>
  <div>
    <p>
      Saxon Trust offers two types of ISAs, a stocks &amp; shares ISA for investment in Secured Shield Bonds and an
      innovative finance ISA or investments in our co-funding platform. These are available for UK tax payers
      only and you can set up one or both ISAs if you qualify and invest up to &pound;20,000 p.a. across all of your ISA accounts currently.
    </p>
    <div class="d-flex justify-content-center my-4 py-4">
      <div class="btn-group">
        <base-button large @click="$emit('isNotQualified')">
          I don't qualify
        </base-button>
        <base-button large @click="$emit('isQualified')">
          I'm a UK tax-payer
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IsaQualify'
}
</script>
